function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { Directives } from '../schema/directives';
var isDefinitionObjectHasDirective = function isDefinitionObjectHasDirective(def, directiveName) {
  if (!def) {
    return false;
  }
  var _iterator = _createForOfIteratorHelper(def),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var node = _step.value;
      var _ref = node,
        type = _ref.operation,
        directives = _ref.directives;
      if (type === 'query' || type === 'mutation') {
        return directives && directives.some(function (directive) {
          return directive.name.value === directiveName;
        });
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
var isQueryContainDirective = function isQueryContainDirective(opt, directiveName) {
  var globalDef = opt.query && opt.query.definitions;
  var childDef = opt.query &&
  // @ts-ignore (TS7053)
  opt.query[opt.operationName] &&
  // @ts-ignore (TS7053)
  opt.query[opt.operationName].definitions;
  return !!(isDefinitionObjectHasDirective(globalDef, directiveName) || isDefinitionObjectHasDirective(childDef, directiveName));
};

/**
 * Util function for determining whether an operation is a "custom query" that
 * is resolved by custom resolvers within the app, or queries intended for the
 * directory service.
 * It does this based on the presence/absence of the @custom directive.
 */
export var isCustomQuery = function isCustomQuery(opt) {
  return isQueryContainDirective(opt, Directives.CUSTOM);
};